import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ti18n from 'i18n!nls/Sequenceri18n';
import SequencerSearchWidget from "../models/audioEditor/SequencerSearchWidget";

const SEARCH_TYPE = SequencerSearchWidget.SEARCH_TYPE;

const EditorSearchHeader = ({ 
    searchType, 
    searchParams, 
    displayRefreshButton, 
    isRefreshing, 
    onInputValueChange, 
    onRefreshButtonClick,
    panelOpened 
}) => {
    const [resultFoundText, setResultFoundText] = useState(window.getI18n(ti18n,"RESULT_FOUND"));
    const [inputPlaceholder, setInputPlaceholder] = useState(window.getI18n(ti18n, "SEARCH_FOR_A_WORD"));
    const searchInputRef = useRef(null);
    const isEditLikeMeMode = searchParams?.isEditLikeMeMode === true || searchParams?.isEditLikeMeMode === "true";

    // Set result found text based on search type
    useEffect(() => {
        switch(searchType){
            case SEARCH_TYPE.TEXT_SEARCH:
                setResultFoundText("");
                break;
            case SEARCH_TYPE.SEMANTIC_SEARCH:
                setResultFoundText("");
                break;
            case SEARCH_TYPE.FILLER_WORDS:
                setResultFoundText(window.getI18n(ti18n, "FILLER_WORDS"));
                break;
            case SEARCH_TYPE.EDIT_BOUNDARIES:
                setResultFoundText(window.getI18n(ti18n, "EDIT_BOUNDARIES"));
                break;
            case SEARCH_TYPE.DISFLUENCY_SEARCH:
                setResultFoundText(window.getI18n(ti18n, "DISFLUENCIES"));
                break;
            case SEARCH_TYPE.SILENCES:
                if (searchParams && searchParams.maxSilenceInMilliseconds !== undefined) {
                    const thresholdSeconds = searchParams.maxSilenceInMilliseconds / 1000;
                    setResultFoundText(`${window.getI18n(ti18n, "SILENCES_LONGER_THAN")} ${thresholdSeconds}s`);
                } else {
                    setResultFoundText(window.getI18n(ti18n, "SILENCES_FOUND"));
                }
                break;
            case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
                setResultFoundText(window.getI18n(ti18n, isEditLikeMeMode ? "ALL_UNNECESSARY_CONTENT_EDIT_LIKE_ME" : "ALL_UNNECESSARY_CONTENT"));
                break;
        }
    }, [searchType, searchParams, isEditLikeMeMode]);

    // Set input placeholder based on search type
    useEffect(() => {
        if(searchType === SEARCH_TYPE.SEMANTIC_SEARCH){
            setInputPlaceholder(window.getI18n(ti18n, "WHAT_ARE_YOU_LOOKING_FOR"));
        }else{
            setInputPlaceholder(window.getI18n(ti18n, "SEARCH_FOR_A_WORD"));
        }
    }, [searchType]);

    // Focus input when panel opens
    useEffect(() => {
        if(panelOpened && searchInputRef && searchInputRef.current){
            searchInputRef.current.focus();
        }
    }, [panelOpened, searchType]);

    const showSearchInput = searchType === SEARCH_TYPE.TEXT_SEARCH || searchType === SEARCH_TYPE.SEMANTIC_SEARCH;

    return (
        <div className="flex flex-row items-center">
            <div className="flex flex-col flex-auto items-start w-full">
                <div className="w-full text-left flex">
                    {showSearchInput ? (
                        <input 
                            ref={searchInputRef} 
                            className="search_input mousetrap" 
                            onChange={onInputValueChange} 
                            placeholder={inputPlaceholder}
                        />
                    ) : (
                        <span className="py-2">{resultFoundText}</span>
                    )}
                    
                    {displayRefreshButton && (
                        <div className="flex flex-row justify-end">
                            <button 
                                className={`button_with_label ${isRefreshing ? 'disabled' : ''}`} 
                                onClick={onRefreshButtonClick} 
                                disabled={isRefreshing}
                            >
                                <label>{window.getI18n(ti18n, "REFRESH")}</label>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

EditorSearchHeader.propTypes = {
    searchType: PropTypes.string,
    searchParams: PropTypes.object,
    displayRefreshButton: PropTypes.bool,
    isRefreshing: PropTypes.bool,
    onInputValueChange: PropTypes.func,
    onRefreshButtonClick: PropTypes.func,
    panelOpened: PropTypes.bool
};

export default EditorSearchHeader;
